<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<breadcrumbs
			:breadcrumbs="page.breadcrumbs"
			:class="page.headingImage ? '' : 'no-slider'"
			:home="defaults[locale].website.hotelName"
		/>

		<main-content :title="page.title || page.header" :content="page.content" :booking-id="page.bookingID" />

		<section class="main-content background-color align-center">
			<div class="row promotions-row flex-row slide-row">
				<div v-for="item in meetingpackagesData" :key="item.filename" class="block flex-item">
					<div class="block-img">
						<div class="price-block">
							<span class="price">{{ item.price }}</span
							><br />per person
						</div>
						<nuxt-link :to="localePath(`/${item.filename}`)">
							<picture>
								<source
									v-if="item.overviewImageWebp"
									:srcset="item.overviewImageWebp"
									type="image/webp"
								/>
								<source :srcset="item.overviewImage" />
								<img loading="lazy" :src="item.overviewImage" :alt="item.overviewImageAlt" />
							</picture>
						</nuxt-link>
					</div>
					<div class="block-content">
						<h3>
							<nuxt-link :to="localePath(`/${item.filename}`)">
								{{ item.header }}
							</nuxt-link>
						</h3>
						<div v-parse-links v-html="item.content" />
						<nuxt-link :to="localePath(`/${item.filename}`)" class="button button-no-fill">
							{{ $t('viewThisPackage') }}
						</nuxt-link>
					</div>
				</div>
			</div>
		</section>

		<contentblocks v-if="page.contentblocks && page.contentblocks.length" :items="page.contentblocks" />

		<review-slider v-if="page.showReviewSlider" :header="defaults[locale].website.reviewsHeader" />
		<frequently-asked-questions
			v-if="page.frequentlyAskedQuestion"
			:header="page.frequentlyAskedQuestion.header"
			:items="page.frequentlyAskedQuestion.faqitems"
		/>
		<pre-footer v-if="page.footerSection.length" :footer-section="page.footerSection[0]" />
		<newsletter
			v-if="page.showNewsletter"
			:header="defaults[locale].website.newsletterHeader"
			:content="defaults[locale].website.newsletterContent"
			:button="defaults[locale].website.newsletterButton"
		/>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { defaults, fetchDefaults } = useDefaults();
const { locale } = useI18n();
const localePath = useLocalePath();

await fetchPage();
await fetchDefaults();

const { data: meetingpackagesData } = await useWebsiteFetch('meetingpackages', {
	query: { language: locale.value },
	key: `${locale.value}/meetingpackages`,
});
</script>

<style lang="scss" scoped>
.price-block {
	position: absolute;
	bottom: 0;
	right: 0;
	z-index: 2;
	background: $cta-color;
	color: #fff;
	padding: 15px;
	font-weight: 400;
	font-size: 12px;
	letter-spacing: 1px;

	.price {
		font-size: 30px;
		width: 100%;
		float: left;
	}
}
</style>
